<mat-card
  appearance="outlined"
  class="card"
  (click)="emitStoreData.emit(store)"
  [ngClass]="{ card__active: cardOnViewing?.Id === store.Id }"
>
  <img
    mat-card-image
    [src]="store.ImageUrl"
    [alt]="'Photo of ' + store.ImageUrl"
    height="auto"
    width="auto"
    class="card__image"
  />
  <mat-card-content>
    <h3 class="location-name">{{ store.Name }}</h3>
    <p class="street-address">
      {{ getAddress() }}
    </p>
  </mat-card-content>
</mat-card>
